import React, { useMemo } from 'react';
import NexlaDefaultLogo from './icons/nexla_icon.svg';
import SidebarItem from 'new/components/SidebarItem';
import { useWhitelabelConfiguration } from 'new/hooks/useWhitelabelConfiguration';
import structure from 'new/routes/structure';
import { filterMainNavigationItemsByTier } from 'new/routes/routes.util';
import { useRestrictedTiers } from 'new/hooks/useRestrictedTiers';
import { useFeatureFlag, useSqlAutomation } from 'new/hooks/useFeatureFlags';
import { ReactComponent as ExpressIcon } from 'new/components/icons/express-icon.svg';
import { ROUTE_EXPRESS } from 'new/constants/pathnames';

import * as S from './styled';

export default function Sidebar() {
  const config = useWhitelabelConfiguration();
  const { hasExpressTierLimitedAccess, hasSelfSignupTierLimitedAccess } = useRestrictedTiers();
  const isAIMenuEnabled = useFeatureFlag('UI_AI_MENU');
  const isTasksEnabled = useSqlAutomation();
  const isExpressEnabled = useFeatureFlag('UI_ENABLE_EXPRESS');

  const logo = config?.sidebar?.logo ? config.sidebar.logo : NexlaDefaultLogo;

  const { mainItems, settingsItem } = useMemo(() => {
    const tierFiltered = filterMainNavigationItemsByTier(
      structure,
      hasExpressTierLimitedAccess,
      hasSelfSignupTierLimitedAccess,
    );

    const filtered = tierFiltered.filter((item) => {
      if (item.name === 'AI' && !isAIMenuEnabled) return false;
      if (item.name === 'Tasks' && !isTasksEnabled) return false;
      return true;
    });

    return {
      mainItems: filtered.filter((item) => item.name !== 'Settings'),
      settingsItem: filtered.find((item) => item.name === 'Settings'),
    };
  }, [
    hasExpressTierLimitedAccess,
    hasSelfSignupTierLimitedAccess,
    isAIMenuEnabled,
    isTasksEnabled,
  ]);

  return (
    <S.SidebarStyled aria-label="sidebar-container">
      <div className="logo-container">
        <img className="logo" alt="logo" src={logo as any} />
      </div>
      <div className="sidebar-items-list">
        {mainItems.map((s) => (
          <SidebarItem key={s.to} label={s.name} icon={s.Icon} href={s.to} />
        ))}
      </div>
      {(settingsItem || isExpressEnabled) && (
        <div className="sidebar-bottom-section">
          {settingsItem && (
            <SidebarItem
              label={settingsItem.name}
              icon={settingsItem.Icon}
              href={settingsItem.to}
            />
          )}
          {isExpressEnabled && (
            <SidebarItem label="Express" icon={<ExpressIcon />} href={ROUTE_EXPRESS} />
          )}
        </div>
      )}
    </S.SidebarStyled>
  );
}
